import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ICrudStrategy } from './icrud-strategy';
import { FieldPath } from '@angular/fire/firestore';

export interface Model {}
export interface CrudQuery {
    field: string | FieldPath;
    operator: WhereFilterOp;
    value: string;
    orderBy: string;
    orderByDirection: OrderByDirection;
}

export type OrderByDirection = 'asc' | 'desc';

export type WhereFilterOp =
    | '<'
    | '<='
    | '=='
    | '!='
    | '>='
    | '>'
    | 'array-contains'
    | 'in'
    | 'array-contains-any'
    | 'not-in';

@Injectable({
    providedIn: 'root',
})
export class CrudService {
    strategy!: ICrudStrategy;
    table = '';

    constructor(@Inject('crudStrategy') strategy: ICrudStrategy) {
        this.strategy = strategy;
    }

    setModel(table: string) {
        this.table = table;
    }

    findFirst<T extends Model>(id: string | number): Observable<T> {
        return this.strategy.findFirst(id);
    }
    findAll<T extends Model>(): Observable<T[]> {
        return this.strategy.findAll();
    }
    countCollection(): Promise<number>{
        return this.strategy.countCollection();
    }
    findWhereCount(queryF: any, order: any): Promise<number>{
        return this.strategy.findWhereCount(queryF, order);
    }
    findWhereGroupCount(queryF: any, order: any): Promise<number>{
        return this.strategy.findWhereGroupCount(queryF, order);
    }
    findAllCollectionGroup<T extends Model>(): Observable<T[]> {
        return this.strategy.findAllCollectionGroup();
    }
    search<T extends Model>(query: CrudQuery): Observable<T[]> {
        return this.strategy.search(query);
    }
    searchCollectionGroup<T extends Model>(query: CrudQuery): Observable<T[]> {
        return this.strategy.searchCollectionGroup(query);
    }
    searchCollectionGroupMany<T extends Model>(query: any[], order: any): Observable<T[]> {
        return this.strategy.searchCollectionGroupMany(query, order);
    }
    create<T>(id: string | number, obj: T): Promise<void> {
        return this.strategy.create(id, obj);
    }
    add<T>(obj: T): Promise<string | number> {
        return this.strategy.add(obj);
    }
    addMany<T>(objectsArray: T[]): Promise<void>{
        return this.strategy.addMany(objectsArray);
    }
    updateMany(oldObjects: any[],newObjects: any[]): Promise<void> {
        return this.strategy.updateMany(oldObjects,newObjects);
    }
    deleteMany(deleteObjects: any[]): Promise<void>{
        return this.strategy.deleteMany(deleteObjects);
    }
    updateOnlyMany(objects: any[]): Promise<void> {
        return this.strategy.updateOnlyMany(objects);
    }
    update<T>(id: string | number, obj: T): Promise<void> {
        return this.strategy.update(id, obj);
    }
    delete<T>(id: string | number): Promise<void> {
        return this.strategy.delete(id);
    }
    simpleSearch<T extends Model>(
        field: string,
        value: string
    ): Observable<T[]> {
        return this.strategy.simpleSearch(field, value);
    }

    findWhere<T extends Model>(
        query: CrudQuery[],
        order: any
    ): Observable<T[]> {
        return this.strategy.findWhere(query, order);
    }
    findOneWhere<T>(queryF: any, order: any): Observable<T | null>{
        return this.strategy.findOneWhere(queryF, order);
    }
}
